import React, { useEffect, useRef, useState } from "react";

export default function CanvasImageLayer({ unlockedTiles }) {
  const canvasRef = useRef(null);
  const [previousTiles, setPreviousTiles] = useState(new Set());

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL;

    async function drawUnlockedTiles() {
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");

      // Fetch tile data from backend
      const response = await fetch(`${API_URL}/tiles/unlocked?user_id=1`);
      const tileData = await response.json();

      // Build new tile set
      const currentTileSet = new Set(tileData.map(({ x, y }) => `${x},${y}`));

      // Determine newly added tiles
      const newTiles = tileData.filter(({ x, y }) => {
        const key = `${x},${y}`;
        return !previousTiles.has(key);
      });

      // Draw all existing tiles
      tileData.forEach(({ x, y, color }) => {
        context.fillStyle = color || "#fff";
        context.fillRect(x, y, 1, 1);
      });

      // Flash new tiles
      newTiles.forEach(({ x, y }) => {
        const flashColor = "#ff00ff"; // neon pink glitch flash
        context.fillStyle = flashColor;
        context.fillRect(x, y, 1, 1);

        // Draw normal color after short delay
        setTimeout(() => {
          context.fillStyle = "#fff";
          context.fillRect(x, y, 1, 1);
        }, 150);
      });

      setPreviousTiles(currentTileSet);
    }

    if (canvasRef.current) {
      drawUnlockedTiles();
    }
  }, [unlockedTiles]);

  return (
    <canvas
      ref={canvasRef}
      width={1000}
      height={1000}
      style={{
        width: "100%",
        height: "auto",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    />
  );
}
